import { Collapse, Modal, ModalBody, ModalHeader } from "reactstrap";
import "./Card.scss";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { ThemeModeContext } from "../../contexts/ThemeModeContext";

export default function CardComponent({
  competences,
  description,
  img,
  subtitle,
  technos,
  title,
  secondTitle,
}) {
  const { themeMode } = useContext(ThemeModeContext);
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { t } = useTranslation();

  const toggleModal = () => setIsOpenModal(!isOpenModal);
  const handleClick = () =>
    window.innerWidth <= 900
      ? setIsOpenCollapse(!isOpenCollapse)
      : setIsOpenModal(!isOpenModal);

  return (
    <div className="cardGlobal">
      <div className={`cardCustom card-theme-${themeMode}`} onClick={handleClick}>
        <img className="card-img" alt={title} src={img} />
        <div className="card-body-custom">
          <h5 className="card-title-custom">{title}</h5>
          <span className="card-second-title">{secondTitle}</span>
          <p className="card-subtitle-custom">{subtitle}</p>
          <div className="techno-list">
            {technos.split(", ").map((tech, i) => (
              <span key={i} className="techno-badge">{tech}</span>
            ))}
          </div>
          <div className="see-more">
            {t("others.see-more")}
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </div>
        </div>
      </div>

      <Collapse isOpen={isOpenCollapse}>
        <div className={`collapseCard card-theme-${themeMode}`}>
          <h4 className="collapseTitle">{title} — {secondTitle}</h4>
          <div className="collapseBody">
            <p>{description}</p>
            {competences.map((competence, id) => (
              <p key={id} className="competence-item">
                <span className="bullet">▸</span> {competence}
              </p>
            ))}
          </div>
        </div>
      </Collapse>

      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        className={`modal-custom card-theme-${themeMode}`}
        contentClassName={`modal-content-custom card-theme-${themeMode}`}
      >
        <ModalHeader toggle={toggleModal} className={`modal-header-custom card-theme-${themeMode}`}>
          <span className="modal-title-text">{title}</span>
          <span className="modal-title-sep"> — </span>
          <span className="modal-subtitle-text">{secondTitle}</span>
        </ModalHeader>
        <ModalBody className={`modal-body-custom card-theme-${themeMode}`}>
          <p className="modal-description">{description}</p>
          <ul className="modal-competences">
            {competences.map((competence, id) => (
              <li key={id}>{competence}</li>
            ))}
          </ul>
        </ModalBody>
      </Modal>
    </div>
  );
}
